"use strict";
// Most runtimes have Intl.NumberFormat but warn users if it doesn't
if (Intl == null || Intl.NumberFormat == null) {
    console.error("This runtime is missing 'Intl.NumberFormat'; it's needed by 'Money.format()'");
}
